/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { logoutUser } from '../../store/actions';

class Logout extends Component {
  /**
   * Redirect to login
   */
  componentDidMount() {
    // emit the event
    this.props.logoutUser(this.props.history);
  }

  // eslint-disable-next-line class-methods-use-this
  render() {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }
}

Logout.propTypes = {
  history: PropTypes.any,
  logoutUser: PropTypes.func,
};

export default withRouter(connect(null, { logoutUser })(Logout));
